module.exports = "<div id=\"dashboard-create-policy-view\">\n  <!--  -->\n  <simple-policy-editor policy=\"vm.policy\"></simple-policy-editor>\n</div>\n"